import create from 'zustand'

export const useCommonStore = create<{
  isComingSoonModalOpen: boolean
  toggleComingSoonModal: () => void
}>((set) => ({
  isComingSoonModalOpen: false,
  toggleComingSoonModal: () => set((state) => ({ isComingSoonModalOpen: !state.isComingSoonModalOpen })),
}))
